import React from 'react';
import type { OperationType } from 'relay-runtime';

export type TErrorRenderer = (ErrorProps: {
  error: Error;
  retry: null | (() => void);
}) => JSX.Element;

function withQueryRenderer<Operation extends OperationType>({
  ErrorRenderer,
}: {
  ErrorRenderer?: TErrorRenderer;
} = {}) {
  const enhancer = (
    Component: React.ComponentType<{
      retry: null | (() => void);
      readonly props?: Operation['response'];
    }>
  ) => ({
    error,
    props,
    retry,
  }: {
    props?: Operation['response'];
    retry: null | (() => void);
    error: Error | null;
  }) => {
    if (error && ErrorRenderer) {
      return <ErrorRenderer retry={retry} error={error} />;
    }

    if (error) {
      throw error;
    }

    return <Component retry={retry} props={props} />;
  };
  return enhancer;
}
export default withQueryRenderer;
